import React, { useState, useEffect } from "react";
import Header from "../../Components/Header/Header";
import Select from "react-select";
import { useLocation } from "react-router-dom";

import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import {
  Image_URL,
  privateRequest,
} from "../../Components/commonApi/CommonApi";
import CustomImage from "../CustomImage/CustomImage";

function Editprovider() {
  const { state } = useLocation();

  const [selectedFile, setSelectedFile] = useState(state?.ProfilePhoto);
  const [imagePreview, setImagePreview] = useState(
    state?.ProfilePhoto && Image_URL + state?.ProfilePhoto
  );

  const [selectedFile1, setSelectedFile1] = useState(state?.AdharCard);
  const [imagePreview1, setImagePreview1] = useState(
    state?.AdharCard && Image_URL + state?.AdharCard
  );

  const [selectedFile2, setSelectedFile2] = useState(state?.PAN_Card);
  const [imagePreview2, setImagePreview2] = useState(
    state?.PAN_Card && Image_URL + state?.PAN_Card
  );

  const [selectedFile3, setSelectedFile3] = useState(state?.Driving_Lience);
  const [imagePreview3, setImagePreview3] = useState(
    state?.Driving_Lience && Image_URL + state?.Driving_Lience
  );

  const [selectedFile4, setSelectedFile4] = useState(state?.HighSchool);
  const [imagePreview4, setImagePreview4] = useState(
    state?.HighSchool && Image_URL + state?.HighSchool
  );

  const [selectedFile5, setSelectedFile5] = useState(state?.Other_document);

  const [imagePreview5, setImagePreview5] = useState(
    state?.Other_document && Image_URL + state?.Other_document
  );

  const [parentCategory, setParentCategoryGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);

  const [name, setName] = useState(state?.Name || "");
  const [Email, setEmail] = useState(state?.Emailid);
  const [Phone, setPhone] = useState(state?.ContactNo);
  const [DOB, setDOB] = useState(state.DOB.slice(0, 10));
  const [Gender, setGender] = useState(state?.Gender);
  const [State, setState] = useState(state?.State);
  const [Address, setAddress] = useState(state?.address);
  const [City, setCity] = useState(state?.city);
  const [Type, setType] = useState(state?.Provider_Type);
  const [ExpertType, setExpertType] = useState(state?.expertType || "prime");
  const [Password, setPassword] = useState(state?.Password);
  const [Status, setStatus] = useState(state.Status);
  const navigate = useNavigate();

  const GetParentCatory = async () => {
    try {
      const response = await privateRequest.get(`/Service/CombineApis`);
      setParentCategoryGroups(response?.data?.data?.ParentGroup);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    if (state) {
      let a = state?.PCGroup.map((item) => ({
        label: item.PCGName,
        value: item._id,
      }));
      console.log("aaaa", a);
      setSelectedGroup(a);
    }
  }, [state]);

  console.log("state", state);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("Name", name);
      formData.append("Emailid", Email);
      formData.append("ContactNo", Phone);
      formData.append("DOB", DOB);
      formData.append("Gender", Gender);
      formData.append("State", State);
      formData.append("address", Address);
      formData.append("Password", Password);
      formData.append("city", City);
      formData.append("Provider_Type", Type);
      formData.append("expertType", ExpertType);
      formData.append("ProfilePhoto", selectedFile ? selectedFile : "");
      formData.append("AdharCard", selectedFile1 ? selectedFile1 : "");
      formData.append("PAN_Card", selectedFile2 ? selectedFile2 : "");
      formData.append("Driving_Lience", selectedFile3 ? selectedFile3 : "");
      formData.append("HighSchool", selectedFile4 ? selectedFile4 : "");
      formData.append("Other_document", selectedFile5 ? selectedFile5 : "");
      selectedGroup.forEach((group) => {
        formData.append("PCGroup", group.value);
      });
      formData.append("Status", Status);

      const response = await privateRequest.post(
        `ServiceProvider/UpdateProvider/${state._id}`,
        formData
      );
      console.log("Provider Update successfully:", response.data);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Provider Update successfully!",
      });
      navigate("/serviceprovider");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response?.data?.message,
      });
      console.error("Error creating service:", error);
    }
  };

  useEffect(() => {
    GetParentCatory();
  }, []);

  return (
    <div className="app has-fullwidth">
      <main className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">
                        Edit Service Provider
                      </span>
                    </p>
                  </div>
                </header>

                <div className="page-section">
                  <div className="card" style={{ borderRadius: "15px" }}>
                    <div className="card-body">
                      <form onSubmit={handleSubmit}>
                        <div className=" row pb-0 mb-0">
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Name</label>
                              <input
                                type="text"
                                id="inputgroupName"
                                className="form-control"
                                placeholder="Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Email-Id</label>
                              <input
                                type="text"
                                id="inputgroupName"
                                className="form-control"
                                placeholder="EmailId"
                                value={Email}
                                onChange={(e) => setEmail(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Phone No</label>
                              <input
                                type="Number"
                                id="inputgroupName"
                                className="form-control"
                                placeholder="Phone No"
                                value={Phone}
                                onChange={(e) => setPhone(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Provider Type</label>
                              <input
                                type="text"
                                id="inputgroupName"
                                className="form-control"
                                placeholder="Type"
                                value={Type}
                                onChange={(e) => setType(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Expert Type</label>
                              <select
                                className="form-control"
                                value={ExpertType}
                                onChange={(e) => setExpertType(e.target.value)}
                                required
                              >
                                <option value="prime">Prime Expert</option>
                                <option value="gold">Gold Expert</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Date of Birth</label>
                              <input
                                type="Date"
                                id="inputgroupName"
                                className="form-control"
                                placeholder="Date of Birth"
                                value={DOB}
                                onChange={(e) => setDOB(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Gender</label>
                              <select
                                className="form-control"
                                value={Gender}
                                onChange={(e) => setGender(e.target.value)}
                              >
                                <option value="">Select</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="other">Other</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>City </label>
                              <input
                                type="text"
                                id="inputgroupName"
                                className="form-control"
                                placeholder="City"
                                value={City}
                                onChange={(e) => setCity(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Address</label>
                              <input
                                type="text"
                                id="inputgroupName"
                                className="form-control"
                                placeholder="Address"
                                value={Address}
                                onChange={(e) => setAddress(e.target.value)}
                              />
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>State</label>
                              <input
                                type="text"
                                id="inputgroupName"
                                className="form-control"
                                placeholder="State"
                                value={State}
                                onChange={(e) => setState(e.target.value)}
                              />
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Password</label>
                              <input
                                type="text"
                                id="inputgroupName"
                                className="form-control"
                                placeholder="Password"
                                value={Password}
                                onChange={(e) => setPassword(e.target.value)}
                              />
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Parent Category Group</label>
                              <Select
                                placeholder={"Parent Category Group"}
                                isMulti
                                options={parentCategory.map((group) => ({
                                  value: group._id,
                                  label: group.PCGName,
                                }))}
                                onChange={(selectedOptions) =>
                                  setSelectedGroup(selectedOptions)
                                }
                                value={selectedGroup}
                              />
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Status</label>
                              <select
                                className="form-control"
                                value={Status}
                                onChange={(e) => setStatus(e.target.value)}
                              >
                                <option value="">Select</option>
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-4">
                          <div className="col-6 col-lg-2 text-center">
                            <CustomImage
                              setImagePreview={setImagePreview}
                              imagePreview={imagePreview}
                              setSelectedFile={setSelectedFile}
                              imageName={"Select Profile Photo"}
                              imageCount={"img1"}
                              downloadNow={true}
                            />
                          </div>
                          <div className="col-6 col-lg-2 text-center">
                            <CustomImage
                              setImagePreview={setImagePreview1}
                              imagePreview={imagePreview1}
                              setSelectedFile={setSelectedFile1}
                              imageName={"Upload Aadhar Card"}
                              imageCount={"img2"}
                              downloadNow={true}
                            />
                          </div>
                          <div className="col-6 col-lg-2 text-center">
                            <CustomImage
                              setImagePreview={setImagePreview2}
                              imagePreview={imagePreview2}
                              setSelectedFile={setSelectedFile2}
                              imageName={"Upload Pan Card"}
                              imageCount={"img3"}
                              downloadNow={true}
                            />
                          </div>

                          <div className="col-6 col-lg-2 text-center">
                            <CustomImage
                              setImagePreview={setImagePreview3}
                              imagePreview={imagePreview3}
                              setSelectedFile={setSelectedFile3}
                              imageName={"Upload Driving Lience"}
                              imageCount={"img4"}
                              downloadNow={true}
                            />
                          </div>

                          <div className="col-6 col-lg-2 text-center">
                            <CustomImage
                              setImagePreview={setImagePreview4}
                              imagePreview={imagePreview4}
                              setSelectedFile={setSelectedFile4}
                              imageName={"Upload High School"}
                              imageCount={"img5"}
                              downloadNow={true}
                            />
                          </div>

                          <div className="col-6 col-lg-2 text-center">
                            <CustomImage
                              setImagePreview={setImagePreview5}
                              imagePreview={imagePreview5}
                              setSelectedFile={setSelectedFile5}
                              imageName={"Upload Other Document"}
                              imageCount={"img5"}
                              downloadNow={true}
                            />
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-lg-12">
                            <button
                              type="submit"
                              className="btn btn-primary btn-sm ml-auto"
                            >
                              <i className="famr-2"></i>Update Provider
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Editprovider;
